import { FONTS_SCHEMA, IFont } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { IDeleteGateway, IListGateway, IUploadGateway } from '../gateways';

export class FontGateway
  implements
    IListGateway<null, IApiResponse<IFont[]>>,
    IUploadGateway<FormData, IApiResponse<IFont[]>>,
    IDeleteGateway<IFont, IApiResponse<IFont[]>>
{
  private readonly restCallBuilder: RestCallBuilder<IFont[]> =
    new RestCallBuilder<IFont[]>([]);

  list(): Observable<IApiResponse<IFont[]>> {
    return this.restCallBuilder
      .get('/fonts/')
      .validate(API_RESPONSE_SCHEMA(FONTS_SCHEMA), 'Font.list')
      .handleMessages()
      .build();
  }

  getFile(font: IFont): Observable<Blob> {
    return this.restCallBuilder.getBlob(
      '/fonts/' + encodeURIComponent(font.name)
    );
  }

  upload(query: FormData): Observable<IApiResponse<IFont[]>> {
    return this.restCallBuilder
      .upload('/fonts/upload/', query)
      .handleMessages()
      .build();
  }

  delete(query: IFont): Observable<IApiResponse<IFont[]>> {
    return this.restCallBuilder
      .delete('/fonts/' + query.id)
      .handleMessages()
      .build();
  }
}
